if (!customElements.get('section-tabs')) {
  customElements.define('section-tabs', class SectionTabs extends HTMLElement {
      constructor() {
        super();
        this.checkboxes = this.querySelectorAll('.field__checkbox');
        this.sections = this.getRelatedSections();
        this.initTabs();
      }

      getRelatedSections() {
        let sections = [];
        let current = this.closest('.section-section-tabs').nextElementSibling;
        
        while (current && current.classList.contains('shopify-section')) {
          sections.push(current);
          current = current.nextElementSibling;
        }
        
        return sections.slice(0, this.checkboxes.length); // Only include tab-controlled sections
      }

      initTabs() {
        if (!this.checkboxes.length || !this.sections.length) return;
        
        // Ensure only the first section is visible initially
        this.sections.forEach((section, index) => {
          section.style.display = index === 0 ? 'block' : 'none';
        });

        // Add event listeners for tab switching
        this.checkboxes.forEach((checkbox, index) => {
          checkbox.addEventListener('change', () => this.setSelectedTab(index));
        });

        // Fix: Ensure the selected tab loads correctly on page load
        this.checkboxes.forEach((checkbox, index) => {
          if (checkbox.checked) {
            this.setSelectedTab(index);
          }
        });
      }

      setSelectedTab(selectedIndex) {
        // Hide all tab-controlled sections
        this.sections.forEach((section, index) => {
          section.style.display = (index === selectedIndex) ? 'block' : 'none';
        });

        // Debugging Log (Can be removed later)
        console.log(`Tab ${selectedIndex + 1} selected. Sections updated.`);
      }
    }
  );
}
